import { createContext, useState } from "react"
import API from "services/api"
import _ from "lodash"

export const PaymentItemContext = createContext({})

const PaymentItemProvider = (props) => {
	const [paymentItems, setPaymentItems] = useState([])
	const [allPaymentItems, setAllPaymentItems] = useState([])
	const [detailItem, setDetailItem] = useState(null)
	const [descOpt1, setDescOpt1] = useState([])
	const [descOpt2, setDescOpt2] = useState([])
	const [groupItem, setGroupItem] = useState(null)

	const getPaymentItem = (params) => {
		return API.getPaymentItem(params)
			.then((res) => {
				const { data } = res

				setPaymentItems(data)
				setAllPaymentItems(data)
				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const getPaymentItemPopulate = (params) => {
		return API.getPaymentItemPopulate(params)
			.then((res) => {
				const { data } = res

				setPaymentItems(data)
				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const getPItemPopulateByID = (params) => {
		return API.getPItemPopulateByID(params)
			.then((res) => {
				const { data } = res
				console.log("context", data)

				setDetailItem(data)
				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const getPItemGrouping = (params) => {
		return API.getPItemGrouping(params)
			.then((res) => {
				const { data } = res

				setGroupItem(data)
				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const postPaymentItem = (sendData) => {
		return API.postPaymentItem(sendData)
			.then((res) => {
				const { data } = res
				getPaymentItem()
				return { data }
			})
			.catch((err) => {
				throw err
			})
	}

	const putPItembyContact = (sendData) => {
		return API.putPItembyContact(sendData)
			.then((res) => {})
			.catch((err) => {
				throw err
			})
	}

	const postManyPaymentItem = (sendData) => {
		return API.postManyPaymentItem(sendData)
			.then((res) => {
				const { data } = res

				return { data }
			})
			.catch((err) => {
				throw err
			})
	}

	const putPaymentItem = (id, sendData) => {
		return API.putPaymentItem(id, sendData)
			.then((res) => {
				const { data } = res
				getPaymentItem()
				return { data }
			})
			.catch((err) => {
				throw err
			})
	}

	const deletePaymentItem = (id) => {
		return API.deletePaymentItem(id)
			.then((res) => {
				const { data } = res
				getPaymentItem()
				return { data }
			})
			.catch((err) => {
				throw err
			})
	}

	// desc item
	const getDescItem = async (params) => {
		await API.getDescItem(params)
			.then((res) => {
				const { data } = res
				const opt1 = data?.filter((x) => x?.category === "opt1")
				const opt2 = data?.filter((x) => x?.category === "opt2")

				setDescOpt1(opt1)
				setDescOpt2(opt2)
			})
			.catch((err) => {
				throw err
			})
	}

	const postDescItem = (sendData) => {
		return API.postDescItem(sendData)
			.then((res) => {
				const { data } = res
				getDescItem()
				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const putDescItem = (id, sendData) => {
		return API.putDescItem(id, sendData)
			.then((res) => {
				const { data } = res
				getDescItem()
				return data
			})
			.catch((err) => {
				throw err
			})
	}

	const deleteDescItem = (id) => {
		return API.deleteDescItem(id)
			.then((res) => {
				const { data } = res
				getDescItem()
				return data
			})
			.catch((err) => {
				throw err
			})
	}

	return (
		<PaymentItemContext.Provider
			value={{
				paymentItems,
				setPaymentItems,
				getPaymentItem,
				postPaymentItem,
				putPItembyContact,
				putPaymentItem,
				deletePaymentItem,

				getPaymentItemPopulate,
				postManyPaymentItem,

				detailItem,
				getPItemPopulateByID,

				descOpt1,
				descOpt2,
				getDescItem,
				postDescItem,
				putDescItem,
				deleteDescItem,

				groupItem,
				setGroupItem,
				getPItemGrouping,

				allPaymentItems
			}}
			{...props}
		/>
	)
}

export default PaymentItemProvider
